import * as React from 'react'

import { t, tc } from '@owl-nest/localize'
import { Link, illustrations } from '@ulule/owl-kit-components/next'

export const FooterContent = {
  rewardBased: [
    {
      content: tc(
        '[link: Ulule] allows creators to fund their projects. By backing, you actively help them make it happen! In return for your support, the creator offers one or more rewards to choose from.',
        {
          link: <Link href="https://www.ulule.com" kind="secondary" underlined />,
        },
      ),
      icon: <illustrations.twoToned.IdeaToAction size={100} />,
      title: t('From idea to action'),
    },
    {
      content: t(
        'Ulule is not an online store. The project must reach 100% of its goal to get funded and deliver rewards.',
      ),
      icon: <illustrations.twoToned.AllOrNothing size={100} />,
      title: t('All or nothing'),
    },
    {
      content: t(
        'All payments are secure and we do not store any credit card information. You can cancel and be refunded at any time while the campaign is still ongoing.',
      ),
      icon: <illustrations.twoToned.SecurePayment size={100} />,
      title: t('Secure and without obligation'),
    },
  ],
  donationBased: [
    {
      content: t('Ulule allows creators to fund their projects. By donating, you actively help them make it happen!'),
      icon: <illustrations.twoToned.IdeaToAction size={100} />,
      title: t('From idea to action'),
    },
    {
      content: t(
        'Every donation counts! Whether or not it reaches its goal, the project will receive all donations at the end of its fundraising.',
      ),
      icon: <illustrations.twoToned.AllOrNothing size={100} />,
      title: t('One donation after another'),
    },
    {
      content: t(
        'All our payments are secure and we do not store any banking information. Funds are managed by our payment provider Mangopay.',
      ),
      icon: <illustrations.twoToned.SecurePayment size={100} />,
      title: t('Secure payment'),
    },
  ],
}

export const FaqData = {
  rewardBased: [
    {
      question: t('How to participate to the project?'),
      answer: tc(
        'Ulule’s principle is to receive a reward in exchange of your support. You need to select the reward you would like to get based on the amount you wish to contribute with (it is possible to make a donation without asking for a reward). \
        [br][br]Click on the Rewards tab to see the list of available rewards and select the one you are interested in. You will be asked to log into your Ulule account or create one if you are not already logged in. Finally proceed to the payment form to support the project. \
        [br][br]Keep also in mind the social aspect of the project: by sharing it to your network, your help the the project getting known and increasing its chances of success!',
        {
          br: <br />,
        },
      ),
    },

    {
      question: t('What happens if the project is not funded?'),
      answer: tc(
        'Project owners only receive the funds if their campaign reach or exceeds the initial defined foal. \
        [br][br]A project is therefore declared non financed if its campaign ends under %(percent)s. Your contribution will then given back to you: \
        [br]Contribution paid by card to an EUR based project: you will receive a refund within 3 working days. \
        [br]Contribution with PayPal or by card to a project based on a currency other than EUR: the payment won’t happen.',
        {
          percent: '100%',
          br: <br />,
        },
      ),
    },
    {
      question: t('When will I be charged?'),
      answer: tc(
        'An Ulule campaign is based on an All or Nothing principle. It means that the projects owners only receive the funds if the campaign goal is reached. \
        [br][br]The payment and the debit of your contribution varies based on your payment method and the currency of the project: \
        [br]Payment by card on a campaign in Euro: the debit takes place at the time of the contribution. If the campaign does not reach its objective, you will get a full refund within a few days after the end of the campaign. \
        [br]Payment by card on a campaign in another currency: The debit only takes place at the end of the campaign if the project was successful. However, an imprint is taken at the time of contribution to verify that you have the funds. This imprint is reimbursed within 7 days.\
        [br]Payment by PayPal: You create a direct debit authorization that only takes place if the goal is achieved at the end of the campaign. Note that payment by Paypal is optional, the option is only activated upon request by the project managers.\
        [br][br]As long as the campaign is active, you have the option to [link: cancel your contribution].',
        {
          br: <br />,
          link: (
            <Link
              href="https://support.ulule.com/hc/articles/213823469-Can-I-cancel-a-donation-"
              kind="secondary"
              target="_blank"
              rel="noopener"
            />
          ),
        },
      ),
    },
    {
      question: t('What personal information will be published?'),
      answer: tc(
        'When you create a profile on Ulule, you specify a certain amount of information that can appear publicly on the Ulule platform and online. The public information is at a minimum your Ulule nickname and, if you make this information public, your first and last name.\
        [br][br]This information will appear in the list of project supporters, in comments if you leave one, and on your public profile.\
        [br][br]You can decide at any time to modify the information you post [link1: from your preferences] and can also [link2: make your contribution anonymous].\
        [br][br]Note that your personal information such as delivery address (if requested) and email address will be shared with the owners of the project you support.',
        {
          br: <br />,
          link1: (
            <Link
              href="https://support.ulule.com/hc/articles/115002098489-Manage-my-profile-settings"
              kind="secondary"
              target="_blank"
              rel="noopener"
            />
          ),
          link2: (
            <Link
              href="https://support.ulule.com/hc/articles/360000983689-Can-I-make-my-contributions-anonymous-"
              kind="secondary"
              target="_blank"
              rel="noopener"
            />
          ),
        },
      ),
    },
  ],
  donationBased: [
    {
      question: t('How to participate to the project?'),
      answer: tc(
        'You can donate by selecting an amount from the suggestions or enter the donation amount yourself in the dedicated field. If the project accepts monthly donations, you will have to choose between making a one-time donation or giving the same amount every month (you can stop at any time from your settings).\
        [br][br]You will be asked to log in to your Ulule account or to create one if you are not already logged in. Finally, you will access the payment form to support the fundraising.\
        [br][br]Think also about the social aspect of the collection: by sharing it with your network, you help the project to be known and increase its chances to get more donations.',
        { br: <br /> },
      ),
    },

    {
      question: t('Can I get a refund for a donation?'),
      answer: tc(
        'The donations you make are final and cannot be cancelled or refunded. If you wish to receive a refund, you must contact the project team and ask them if they can give you back the amount you donated. This will be a private transaction outside of Ulule.\
        [br][br]In the event that the project team decides to cancel its fundraising, all donations will be fully refunded.',
        { br: <br /> },
      ),
    },
    {
      question: t('When will I be charged?'),
      answer: tc(
        'Payment and debiting of your transaction take place immediately at the time of contribution.\
        [br][br]Funding recipients receive the funds when they make a transfer request.',
        { br: <br /> },
      ),
    },
    {
      question: t('What personal information will be published?'),
      answer: tc(
        'When you create a profile on Ulule, you specify a certain amount of information that can appear publicly on the Ulule platform and online. The public information is at a minimum your Ulule nickname and, if you make this information public, your first and last name.\
        [br][br]This information will appear in the list of project supporters, in comments if you leave one, and on your public profile.\
        [br][br]You can decide at any time to modify the information you post from your preferences and can also make your contribution anonymous.\
        [br][br]Note that your personal information such as delivery address (if requested) and email address will be shared with the owners of the project you support.',
        { br: <br /> },
      ),
    },
  ],
}
